<script setup lang="ts">

import { fenToYuan } from '@/utils/price';
import { useGameConfigStore } from '@/stores/gameConfig';

defineOptions({
  name: 'FlipCoinDesc'
});

const { getFlipCoinConfig } = toRefs(useGameConfigStore());
const { updateFlipCoinConfig } = useGameConfigStore();

onMounted(() => {
  updateFlipCoinConfig();
});

const isDark = import.meta.env.VITE_APP_DARK_MODE === 'true';

</script>

<template>
  <q-card class="bg-common radius-bottom-sm q-pa-md">
    <q-card-section class="row items-center q-pa-none">
      <div class="radius-sm q-pa-md text-primary q-gutter-xs"
           :class="isDark ? 'desc-box-dark' : 'desc-box-light'">
        <div class="q-mb-md text-weight-bold">
          Coin Flip is a fun game where you can win huge profits by choosing "Heads" or "Tails"!
        </div>

        <div>
          1. Enter bet amount by clicking "1/2" or "2x", the minimum bet amount is
          {{ fenToYuan(getFlipCoinConfig.minPrice || 1000) }}.
        </div>
        <div>
          2. Choose HEAD or TAIL.
        </div>
        <div>
          3. Once you win, you will obtain {{ getFlipCoinConfig.odds || 1.98 }}×Bet amount.
        </div>
      </div>
    </q-card-section>
  </q-card>
</template>

<style lang="scss" scoped>

</style>